import React, { Component } from 'react';
import LoginForm from './login-form';
import { userLoginRequest, processRequestToCognito, getIdentityProfile } from '../../actions/login-action';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import logo from '../../assets/images/logo.png'
import virtualLogo from '../../assets/images/virtual-logo.png'
import stemLabsLogo from '../../assets/images/stem-labs.png'
import TextFieldGroup from "../forms/text-field-group";
import { Button, Modal, Alert } from "react-bootstrap";
import {
    CognitoUserPool,
    AuthenticationDetails,
    CognitoUser,
} from 'amazon-cognito-identity-js';
import config from '../../config.js'
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import apiClient from "../../actions/api-client";
import ProgressIndicator from "../progress-indicator/progress-indicator";
import ClevertapReact from "clevertap-react";
import './login.css'
import logo2 from '../../assets/images/logo2.png'
import { PoweredByLearnerPal } from '../footer/PoweredByLearnerPal.js';

class Login extends Component {

    constructor(props) {
        super(props);
        this.getForgerPasswordDialog = this.getForgerPasswordDialog.bind(this);
        this.onChange = this.onChange.bind(this);
        this.forgetPassword = this.forgetPassword.bind(this);
        this.getValidationState = this.getValidationState.bind(this);
        this.confirmPassword = this.confirmPassword.bind(this);
        this.isValid = this.isValid.bind(this);

        this.state = {
            showForgetPasswordDialog: false, userName: '', codeSent: false, confirmPassword: '', loading: false,
            verificationCode: '', newPassword: '', errors: {}, showAlert: false, alertText: '', alertStyle: '',
            autoSignIn: props.location && props.location.query && props.location.query.autoSignIn ? props.location.query.autoSignIn : '',
            autoSigninPath: props.location && props.location.query && props.location.query.pathname ? props.location.query.pathname : ''
        }
    }

    componentDidMount(){
      document.getElementById('favicon').setAttribute('href', logo2)
    }

    onChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    forgetPassword() {

        this.setState({ showForgetPasswordDialog: false });
        let that = this;
        let userPool = new CognitoUserPool({
            UserPoolId: config.userPoolId,
            ClientId: config.clientId
        });
        let cognitoUser = new CognitoUser({
            Username: this.state.userName,
            Pool: userPool
        });
        cognitoUser.forgotPassword({
            onSuccess: function () {

                that.setState({ codeSent: true, showForgetPasswordDialog: true });
            },
            onFailure: function (err) {

                let errors = {};
                errors.userName = err.message;
                that.setState({ errors });
                that.setState({ showForgetPasswordDialog: true });
            }
        });
    }
    confirmPassword() {
        let that = this;
        if (this.isValid()) {
            let userPool = new CognitoUserPool({
                UserPoolId: config.userPoolId,
                ClientId: config.clientId
            });
            let cognitoUser = new CognitoUser({
                Username: this.state.userName,
                Pool: userPool
            });
            cognitoUser.confirmPassword(this.state.verificationCode, this.state.newPassword, {
                onFailure(err) {
                    let errors = {};
                    errors.verificationCode = err.message;
                    that.setState({ errors });
                    that.setState({ showForgetPasswordDialog: true });
                },
                onSuccess(result) {
                    ClevertapReact.event("User Password Reset", { 'userName': that.state.userName });
                    that.setState({ showForgetPasswordDialog: false, showAlert: true, alertText: 'Password successfully reset, Please login with your new password', alertStyle: 'success' });
                    setTimeout(() => {
                        that.setState({ ...that.state, showAlert: false });
                    }, 5000);
                },
            });
        }
    }

    getValidationState() {
        let errors = {};
        if (this.state.newPassword.length < 6) {
            errors.password = 'Your password must be at least 6 characters';
        }
        if (this.state.newPassword !== this.state.confirmPassword) {
            errors.password = 'Passwords do not match';
            errors.confirmPassword = 'Passwords do not match';
        }
        if (Validator.isEmpty(this.state.newPassword)) {
            errors.newPassword = 'This field is required';
        }
        if (Validator.isEmpty(this.state.confirmPassword)) {
            errors.confirmPassword = 'This field is required';
        }
        if (Validator.isEmpty(this.state.userName)) {
            errors.userName = 'This field is required';
        }
        if (this.state.userName.trim().indexOf(" ") > -1) {
            errors.userName = 'The username cannot contain spaces';
        }
        if (this.state.userName.search(/[!@#$%^&*]/) > -1) {
            errors.userName = 'Special characters are not allowed in the code';
        }
        if (Validator.isEmpty(this.state.verificationCode)) {
            errors.verificationCode = 'This field is required';
        }
        if (this.state.verificationCode.trim().indexOf(" ") > -1) {
            errors.verificationCode = 'The username cannot contain spaces';
        }
        if (this.state.verificationCode.search(/[!@#$%^&*]/) > -1) {
            errors.verificationCode = 'Special characters are not allowed in the code';
        }

        return {
            errors,
            isValid: isEmpty(errors)
        }
    }

    isValid() {
        const { errors, isValid } = this.getValidationState();
        if (!isValid) {
            this.setState({ errors });
        }
        return isValid;
    }

    getForgerPasswordDialog() {
        let errors = this.state.errors;
        let body =
            <div>
                {!this.state.codeSent &&
                    <div>
                        <p>Please enter your username and get a verification code on your registered email address</p>
                        < TextFieldGroup
                            error={errors.userName}
                            field="userName"
                            id="userName"
                            value={this.state.userName}
                            placeholder="Enter UserName"
                            onChange={this.onChange}
                        />
                    </div>
                }
                {this.state.codeSent &&
                    <div>
                        <p>Please enter the code sent to you on your email address</p>
                        <TextFieldGroup
                            error={errors.verificationCode}
                            field="verificationCode"
                            id="verificationCode"
                            value={this.state.verificationCode}
                            placeholder="Enter verification Code"
                            onChange={this.onChange}
                            label="Verification Code"
                        />
                        <TextFieldGroup
                            error={errors.newPassword}
                            type='password'
                            field="newPassword"
                            id="newPassword"
                            value={this.state.newPassword}
                            placeholder="Enter New Password"
                            onChange={this.onChange}
                            label="New Password"
                        />
                        <TextFieldGroup
                            error={errors.confirmPassword}
                            type='password'
                            field="confirmPassword"
                            id="confirmPassword"
                            value={this.state.confirmPassword}
                            placeholder="Confirm New Password"
                            onChange={this.onChange}
                            label="Confirm Password"
                        />
                    </div>
                }
            </div>;
        return <Modal
            show={this.state.showForgetPasswordDialog}
            onHide={() => {
                this.setState({ showForgetPasswordDialog: false });
            }}
            container={this}
            aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="delete-activity-modal">Forget Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => {
                    this.setState({ showForgetPasswordDialog: false });
                }}>Cancel</Button>
                <Button onClick={() => {
                    let body = {
                        userName: this.state.userName
                    };
                    let that = this;
                    that.setState({ showForgetPasswordDialog: false, loading: true });
                    apiClient.invokeApi({}, '/forgetpassword', 'POST', {}, body, "4").then(function (result) {
                        that.setState({ loading: false, showAlert: true, alertText: result.data, alertStyle: 'success' });
                        setTimeout(() => {
                            that.setState({ ...that.state, showAlert: false });
                        }, 5000);
                    }).catch(function (result) {

                        that.setState({ loading: false, showAlert: true, alertText: (result.data ? result.data : result.response.data.errors.map(value => value.message).join(", ")), alertStyle: 'danger' });
                        setTimeout(() => {
                            that.setState({ ...that.state, showAlert: false });
                        }, 5000);
                    });
                }} bsStyle='primary'>Get Password</Button>
                {/*{!this.state.codeSent &&*/}
                {/*<Button onClick={()=> {*/}
                {/*this.setState({codeSent:true});*/}
                {/*}} bsStyle='primary'>I have a code</Button>*/}
                {/*}*/}
                {/*<Button onClick={()=> {*/}
                {/*{!this.state.codeSent && this.forgetPassword();}*/}
                {/*{this.state.codeSent && this.confirmPassword();}*/}
                {/*}} bsStyle='primary'>{!this.state.codeSent && 'Get Code'}{this.state.codeSent && 'Reset Password'}</Button>*/}
            </Modal.Footer>
        </Modal>;
    }

    render() {
        const { userLoginRequest, processRequestToCognito, getIdentityProfile } = this.props;
        return (
            <div className="loginPage">
                <div className="loginPage">
                    <div>
                        <div className="topBar" />
                        <div className="wrapper"> 
                            <a href="#" className="LogoAnch">
                                <img src={virtualLogo} alt="-" className="logoClass" />
                                <img src={stemLabsLogo} alt="-" className="logoClass" />
                            </a>
                            <LoginForm userLoginRequest={userLoginRequest} processRequestToCognito={processRequestToCognito} getIdentityProfile={getIdentityProfile} routepath={this.state.autoSigninPath} />
                            <div className="lastAncBlock">
                                <p><strong> Don’t have an account?</strong> <a href="/signup" className="achForm"><strong> Create Account</strong></a></p>
                                <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ showForgetPasswordDialog: true }) }} className="achForm">Lost your ID or Password?</a>
                                <p style={{ textAlign: "center" }}> -- or -- </p>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showForgetPasswordDialog && this.getForgerPasswordDialog()}
                {this.state.showAlert &&
                    <div className="row">
                        <div className="col-md-3 col-xs-3" />
                        <div className="col-md-6 col-xs-3">
                            <Alert bsStyle={this.state.alertStyle}
                                onDismiss={this.handleAlertDismiss}>
                                {this.state.alertText}
                            </Alert>
                        </div>
                        <div className="col-md-3 col-xs-3" />
                    </div>
                }
                <ProgressIndicator show={this.state.loading} />
                <PoweredByLearnerPal />
            </div>
        );
    }
}

Login.propTypes = {
    userLoginRequest: PropTypes.func.isRequired,
    processRequestToCognito: PropTypes.func.isRequired,
    getIdentityProfile: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return { ...state };
}

export default connect(mapStateToProps, { userLoginRequest, processRequestToCognito, getIdentityProfile })(Login);
